import { render, staticRenderFns } from "./AddLocalPostcode.vue?vue&type=template&id=15cb365f&scoped=true"
import script from "./AddLocalPostcode.vue?vue&type=script&lang=js"
export * from "./AddLocalPostcode.vue?vue&type=script&lang=js"
import style0 from "./AddLocalPostcode.vue?vue&type=style&index=0&id=15cb365f&prod&scoped=true&lang=css"
import style1 from "./AddLocalPostcode.vue?vue&type=style&index=1&id=15cb365f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cb365f",
  null
  
)

export default component.exports